export enum AccountType {
  POINT = 1,
  CASH = 2,
}

export class UserAccount {
  accountType: AccountType;
  balance: string;
  readonly transactions: AccountTransaction[];
  readonly userId: number;
}

export enum AccountTransactionSource {
  SLM,
  CLOCK_IN,
  PAYMENT_INVOICE,
  CHECK_IN,
  ACCOUNT_MERGE,
}

export class AccountTransaction {
  id: number;
  amount: number;
  remark: string;
  source: AccountTransactionSource;
  createdAt: string;
}



// WEBPACK FOOTER //
// ./src/types/userAccount.ts